export default "__VITE_ASSET__e774f766__"